import CardVacante from './CardVacante';

export default CardVacante;